import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import React from "react";
import Grid from "@material-ui/core/Grid";
import {
	IconButton,
	PrimaryButton,
	SecondaryButton
} from "@prestosports/commons-ui";
import Close32 from "@carbon/icons-react/lib/close/32";
import { Box } from "@material-ui/core";
import commonStyles from "../styles/Common.styles";
import SettingConfirmationListItem from "./SettingConfirmationListItem";

const SettingConfirmationDialog = ({
	isOpen,
	onClose,
	onSave,
	changeSummary = {}
}) => {
	const commonClasses = commonStyles();

	return (
		<Dialog
			open={isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			onClose={onClose}
		>
			<DialogTitle id="alert-dialog-title">
				Confirm Changes
				<IconButton
					onClick={onClose}
					aria-label="close-dialog"
					className={commonClasses.closeButton}
				>
					<Close32 />
				</IconButton>
			</DialogTitle>
			<DialogContent dividers>
				<DialogContentText id="alert-dialog-description">
					Are you sure you want to save these changes?
					<Box mt={1}>
						{Object.keys(changeSummary).map((key) => {
							const section = key.charAt(0).toLocaleUpperCase() + key.slice(1);
							const changes = changeSummary[key];
							return changes.length ? (
								<SettingConfirmationListItem section={section} changes={changes} />
							) : null;
						})}
					</Box>
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Grid container direction="row" justifyContent="flex-end" spacing={2}>
					<Grid item>
						<SecondaryButton label="Close" onClick={onClose} size="medium" />
					</Grid>
					<Grid item>
						<PrimaryButton label="Save" onClick={onSave} size="medium" />
					</Grid>
				</Grid>
			</DialogActions>
		</Dialog>
	);
};

export default SettingConfirmationDialog;
